import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sch_condition_wrap" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "info_box" }
const _hoisted_4 = { class: "col_blue" }
const _hoisted_5 = { class: "col_blue" }
const _hoisted_6 = { class: "col_blue" }
const _hoisted_7 = { class: "common_table custom_scroll" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "left" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createTextVNode(" 총 게시물 ", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.sum)) + "개", 1)
          ]),
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createTextVNode(" 총 신청자 ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.sumApply)) + "명", 1)
          ]),
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" 총 선발인원 ", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.sumPick)) + "명", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", null, [
        _cache[5] || (_cache[5] = _createElementVNode("colgroup", null, [
          _createElementVNode("col"),
          _createElementVNode("col", { style: {"width":"200px"} }),
          _createElementVNode("col", { style: {"width":"150px"} }),
          _createElementVNode("col", { style: {"width":"150px"} })
        ], -1)),
        _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "left" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "게시물 제목"),
            _createElementVNode("th", null, "진행기간"),
            _createElementVNode("th", null, "신청인원"),
            _createElementVNode("th", null, "당첨인원")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                  _createElementVNode("td", null, _toDisplayString(item.title), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.recruitStartDate), ".", false)) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.recruitEndDate), ".", false)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.applyCnt)) + "명", 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cntWin)) + "명", 1)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("td", { colspan: "5" }, [
                  _createElementVNode("div", {
                    class: "tb_subject",
                    style: {"text-align":"center","width":"100%"}
                  }, "데이터가 없습니다.")
                ], -1)
              ]))]))
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 0,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}